<div class="settings-tab">
  <div class="agreements-section">
    @if (currentLinks.length > 0) {
      <div class="agreements-list">
        @for (link of currentLinks; track link) {
          <div class="agreement-item">
            <!-- If it's a URL, render like before -->
            @if (link.url) {
              <a
                [href]="link.url"
                target="_blank"
                rel="noopener noreferrer"
                class="agreement-link">
                {{ link.title }}
              </a>
            }
            <!-- If it's an action (our TOS), render a button that opens the dialog -->
            @if (!link.url) {
              <a
                type="button"
                class="agreement-link as-button"
                style="cursor: pointer;"
                (click)="openLink(link)">
                {{ link.title }}
              </a>
            }
          </div>
        }
      </div>
    } @else {
      <div class="no-agreements">
        <p>No agreements available at this time.</p>
      </div>
    }

  </div>
</div>
